// extracted by mini-css-extract-plugin
module.exports = {"detailViewContainer":"detailCellRenderer_detailViewContainer__DRxK1"};